// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qZmt","label":"styles_label__4kBmB"};